import * as React from 'react';
import { Tile, TileAssets } from '../../../models/Mahjong';

interface TileImageProps {
    tile: Tile;
    height?: number;
    faceDown?: boolean;
}

export function TileImage({ tile, height = 60, faceDown = false }: TileImageProps): JSX.Element {
    const getTileKey = (t: Tile): string => {
        if (faceDown) {
            return 'back';
        }
        if (t.isRed) {
            return `${t.type}_${t.value}_red`;
        }
        return `${t.type}_${t.value}`;
    };

    const width = height * (44 / 60);

    return (
        <img
            src={TileAssets[getTileKey(tile)] ?? TileAssets['back']}
            alt={tile.id}
            style={{ height: `${height}px`, width: `${width}px` }}
            className="mahjong-tile"
        />
    );
}
